import { render, staticRenderFns } from "./SharedEventUserDetails.vue?vue&type=template&id=a00dea64"
import script from "./SharedEventUserDetails.vue?vue&type=script&lang=js"
export * from "./SharedEventUserDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports